import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbDropdownModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HeaderComponent} from './header.component';
import {MenuBarModule} from '../menu-bar/menu-bar.module';
import {NotificationModule} from '../notification/notification.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    MenuBarModule,
    NgbDropdownModule,
    NotificationModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule {
}
